import { CrmMenuItem } from '@touch4it/ng-swp/menu';

import { getUserRole } from '../crm/user/helpers/get-user-role';
import { User, UserPermissions } from '../crm/user/user';

export type MenuItem = {
  permission: keyof UserPermissions;
} & CrmMenuItem;

export const isAllowedMenuItem = (menuItem: MenuItem, user: User): boolean => {
  const permissions = user.permissions ?? {};
  const userRole = getUserRole(user);

  if (menuItem.role) {
    if (Array.isArray(menuItem.role)) {
      return menuItem.role.includes(userRole);
    } else {
      return menuItem.role === userRole;
    }
  }

  if (menuItem.permission) {
    return permissions[menuItem.permission]?.display ?? false;
  }

  return true;
};
